// extracted by mini-css-extract-plugin
export default {"div":"TrackinApp_div__8NY8V","header":"TrackinApp_header__q+Ynl","text":"TrackinApp_text__99rXd","div2":"TrackinApp_div2__0wmsh","btn":"TrackinApp_btn__FOYZ0"};